/*global jQuery, google */
(function($) {

  'use strict';

  $(function() {

    

    var setBackground = function(){
      var $next = $('.link_banner.selected').removeClass('selected').next('.link_banner');
      if ($next.length) {
          $next.addClass('selected'); 
      } else {
          $(".link_banner:first").addClass('selected');
      }

      


      if ($('.link_banner.selected').length) {

        var bg = $('.link_banner.selected').data('bg');
        console.log(bg);

        var _image = new Image();
        _image.id = 'newImageId';
        _image.src = bg;

        $(_image).one("load", function() {
          $('div.bg_banner').css('background-image', 'url(' + bg + ')');
          $('div.bg_banner').fadeTo(2000, 1);
          $('.link_banner').hide();
          $('.link_banner.selected').css({
              "margin-left": "-20px",
              "opacity":"0",
              "display":"block",
          }).show().animate({"opacity":1, "margin-left":0})
        });

      }
      //$('.bg_banner').css('background-image', 'url(' + bg + ')');
    }
    
    $('.link_banner').hide();
    $('.link_banner.selected').show();

    var bg = $('.link_banner.selected').data('bg');
    $('.bg_banner').css('background-image', 'url(' + bg + ')');
    
    setInterval(function(){
      setBackground();
    },5000);

    var bounceStartPosition = 0;
    var headerHeight = $('#header').height();
    var windowHeight = $(window).height();
    bounceStartPosition = windowHeight;
    if (bounceStartPosition > headerHeight) bounceStartPosition = headerHeight;

    $( window ).resize(function() {
      headerHeight = $('#header').height();
      windowHeight = $(window).height();
      bounceStartPosition = windowHeight;
      if (bounceStartPosition > headerHeight) bounceStartPosition = headerHeight;

      console.log(headerHeight);
      console.log(windowHeight);
      console.log(bounceStartPosition);
      $('.frecciagiu').stop().clearQueue().css('top', bounceStartPosition-150);
      bounce();
    });

    var bounce = function() {
      $('.frecciagiu').animate({ top: bounceStartPosition-200 }, {duration: 1000}).animate({ top: bounceStartPosition-150 }, {duration: 500});
    }
    setInterval(function(){ bounce() }, 1500);
    bounce();


  });

}(jQuery));
